import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Link } from '@ta-interaktiv/contentbricks'

export const isMobile: boolean = browserCheck.isMobile

const updates = { evening: 'Wird am Dienstag aktualisiert' }

const metaCases = 'Fälle'

export const localesHospitalMultiples = {
  title: 'Covid-19-Patienten aktuell in Spitalpflege',
  subline: (
    <>
      GE: Bis 18. Mai 2020 Reha-Patienten mitgerechnet. SZ und UR: Keine oder
      nur teilweise Daten der 1. Welle. AI: Keine Daten.
    </>
  ),
  link: (
    <>
      So ausgelastet sind die Spitäler in den Kantonen:{' '}
      <Link href='689821411167'>Zur Übersicht</Link>.
    </>
  ),
  update: updates.evening,
  swissTitle: 'Schweizweit',
  keyHosp: 'Hospitalisiert',
  keyIntensive: 'Davon auf der Intensivstation',
  metaCases: metaCases,
  showMoreClosed: 'Alle Kantone anzeigen…',
  showMoreOpened: 'Zusätzliche Kantone ausblenden',
  noData: 'Keine Daten',
  emptyData: 'Keine Angaben',
  timerange: ['Zeitraum']
}
